export default "/_next/static/images/Bohemian-e9d102715c63074f8104396765dbd8eb.png";